// extracted by mini-css-extract-plugin
export default {"main_container":"Main_main_container__ITNF6","hero":"Main_hero__S2I02","hero_content":"Main_hero_content__Id2dR","primary_btn":"Main_primary_btn__KOgEA"};